import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const displaySizeSelector = (state: RootState) => state.displaySize;

export const getDisplaySize = createSelector(
  displaySizeSelector,
  (displaySize: any) => displaySize.text_scale,
);
